import React, { Component } from 'react';
import './AirDatePickerInput.css';
import { ArrowDownIcon } from '../../../icons';
export default class AirDatePickerInput extends Component {
  render() {
    return (
      <div onClick={this.props.onClick} className="AirDatePickerInput">
        <div className="prefix">{this.props.prefix}</div>
        <div className="value">{this.props.value}</div>
        <div className="suffix">
          <ArrowDownIcon />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirDatePicker/AirDatePickerInput/AirDatePickerInput.js